module.exports = __webpack_public_path__ + "img/message.cafee85b.svg";